export function Seo({
  title,
  description,
  children
}: { title?: string; description?: string; children?: React.ReactNode }) {
  return (
    <>
      {title && (
        <title>{`${title} | BetterTime`}</title>
      )}
      <meta name="description" content={description} />
      {children}
    </>
  );
}
